import script from "./TimeDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeDisplay.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__